import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getSinglePaperStart,
  resetSinglePaperLoading,
} from "../../redux/paper/reducer";
import {
  selectIsFetchingPaper,
  selectSinglePaper,
} from "../../redux/paper/selectors";

const useSinglePaperGet = ({ id }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsFetchingPaper);
  const paper = useSelector(selectSinglePaper);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const getPaper = useCallback(() => {
    if (!id) return;
    dispatch(getSinglePaperStart(id));
  }, [dispatch, id]);

  const resetLoading = () => {
    dispatch(resetSinglePaperLoading());
  };

  useEffect(() => {
    if (!id) return;
    getPaper();
  }, [id, getPaper, fetch]);

  return {
    paper,
    loadingPaper: isLoading,
    resetLoading,
    refetch,
  };
};

export default useSinglePaperGet;
